import isEditMode from "../isEditMode"
import logTrackPayload from "./helpers/logTrackPayload"

const DEBUG = false;

/**
 * 
 * @param {object} obj 
 * 
 * Object takes the shape of what we should pass into GTM
 * 
 * trackEvent({
 *  event: "outbound_link",
 *  url: "http://www.google.com",
 *  interaction_type: "outbound_link"
 * })
 */

export const trackEvent = (obj) => {
  if (DEBUG || localStorage.getItem("track_debug")) {
    console.group(`Track event ${obj.event}`);
    logTrackPayload(obj);
    console.groupEnd();
  }

  // Use try to prevent js issues with ad blockers
  try {
    if (window.dataLayer && !isEditMode()) { // Don't run in edit mode
      if (obj.ecommerce) {
        window.dataLayer.push({ ecommerce: null });
      }
      window.dataLayer.push(obj);
    }
  } catch (error) {
    console.warn(error);
  }
};